import { baseForPdf } from '../apiClients';
import { getLocalUserId, getZl_UID } from '../../components/shared/getToken';
import { Endpoints } from '../../network';

export interface IPersonalityTestPayload {
  categoryId: string;
  answers: {
    questionId: string;
    optionId: string;
  }[];
}

export interface IOnboardingPayload {
  categoryId: string;
  answers: {
    questionId: string;
    optionId: string[];
  }[];
}

export const getCategoriesAPI = async (type?: string): Promise<any> => {
  const queryParams = new URLSearchParams({
    ...(type !== undefined && { type }),
  });

  const response = await baseForPdf.get(
    `${Endpoints.getAllCategory}?${queryParams}`,
  );
  return response?.data;
};

export const getResultData = async (slug: string): Promise<any> => {
  const response = await baseForPdf.get(`${Endpoints.getResultData}/${slug}`);
  return response?.data;
};

export const postPersonalityResponse = async (
  data: IPersonalityTestPayload,
  email?: string,
) => {
  const [zl_uid, localUserId] = await Promise.all([
    getZl_UID(),
    getLocalUserId(),
  ]);

  if (!zl_uid && !localUserId) {
    return [];
  }

  const payload = {
    tempUserId: localUserId,
    zl_uid: zl_uid,
    ...data,
    ...(email && { email }),
  };

  const response = await baseForPdf.post(
    `${Endpoints.submitResponse}`,
    payload,
  );

  return response?.data;
};

export const postOnboardingResponse = async (
  data: IOnboardingPayload,
  email?: string,
) => {
  const [zl_uid, localUserId] = await Promise.all([
    getZl_UID(),
    getLocalUserId(),
  ]);

  if (!zl_uid && !localUserId) {
    return [];
  }

  const payload = {
    tempUserId: localUserId,
    zl_uid: zl_uid,
    ...data,
    ...(email && { email }),
  };

  const response = await baseForPdf.post(
    `${Endpoints.submitOnboardingResponse}`,
    payload,
  );

  return response?.data;
};

export const getQuestionsAPI = async (categoryId: string): Promise<any> => {
  const response = await baseForPdf.get(`${Endpoints.questions}/${categoryId}`);
  return response?.data;
};
export const getUserPersonalityAPI = async (email?: string): Promise<any> => {
  const [zl_uid, localUserId] = await Promise.all([
    getZl_UID(),
    getLocalUserId(),
  ]);

  const queryParams = new URLSearchParams({
    ...(localUserId && { tempUserId: localUserId }),
    ...(zl_uid && { zl_uid: zl_uid }),
    ...(email && { email }),
  });
  if (!zl_uid) {
    return [];
  }

  const response = await baseForPdf.get(
    `${Endpoints.submitResponse}?${queryParams.toString()}`,
  );
  return response?.data;
};

export const getOnBoardingAnswersAPI = async (): Promise<any> => {
  const [zl_uid] = await Promise.all([getZl_UID()]);

  const response = await baseForPdf.get(
    `${Endpoints.resultOnboardingResponse}?zl_uid=${zl_uid}`,
  );
  return response?.data;
};
